import { render, staticRenderFns } from "./type-to-confirm.vue?vue&type=template&id=58922cf2"
import script from "./type-to-confirm.vue?vue&type=script&lang=js"
export * from "./type-to-confirm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports